const _links=[
    {
      title:'CHIKYUJIN',
      localizing:'chikyujin',
      img:require('@/assets/img/chikyujin.png'),
      url:'https://job.chikyujin.jp/',
      alt:'chikyujin',
    },
    {
      title:'Community',
      localizing:'community',
      img:require('@/assets/img/community.png'),
      url:'Rooms',
      alt:'コミュニティ',
    },
    {
      title:'FAQ',
      localizing:'FAQ',
      img:require('@/assets/img/FAQ.png'),
      url:'https://choy-san.jp/service/support',
      alt:'Faq',
    },
    {
      title:'Find a job',
      localizing:'jobOffer',
      img:require('@/assets/img/01Find_a_job.png'),
      url:'job',
      alt:'仕事紹介',
    },
    {
      title:'Insurance',
      localizing:'insurance',
      img:require('@/assets/img/02Insurance.png'),
      url:'insurance',
      alt:'保険',
    },
    {
      title:'Overseas Remittance',
      localizing:'overseasRemittance',
      img:require('@/assets/img/03Overseas_remittance.png'),
      url:'remittance',
      alt:'Remittance',
    },
    {
      title:'Online Education',
      localizing:'onlineEducation',
      img:require('@/assets/img/04Online_education.png'),
      url:'education',
      alt:'OnlineEducation',
    },
    {
      title:'Online Shopping',
      localizing:'onlineShopping',
      img:require('@/assets/img/05Online_shopping.png'),
      url:'shopping',
      alt:'OnlineShopping',
    },
    {
      title:'Mobile Phone SIM',
      localizing:'mobilePhone',
      img:require('@/assets/img/06Mobilephone_SIM.png'),
      url:'mobile',
      alt:'MobilePhoneSim',
    },
    {
      title:'Real Estate',
      localizing:'realEstate',
      img:require('@/assets/img/07Real_estate.png'),
      url:'estate',
      alt:'RealEstate',
    },
    {
      title:'Entertainment',
      localizing:'entertainment',
      img:require('@/assets/img/08Entertainment.png'),
      url:'enter',
      alt:'Entertainment',
    },
    {
      title:'Travel',
      localizing:'travel',
      img:require('@/assets/img/09Travel.png'),
      url:'travel',
      alt:'Travel',
    },
    {
      title:'Game',
      localizing:'game',
      img:require('@/assets/img/10GAME.png'),
      url:'game',
      alt:'Game',
    },
    {
      title:'For Corporate',
      localizing:'forCorporate',
      img:require('@/assets/img/11For_Corporate.png'),
      url:'corporate',
      alt:'For Corporate',
    },
    {
      title:'For Freelance',
      localizing:'forFreelance',
      img:require('@/assets/img/12For_freelance.png'),
      url:'freelance',
      alt:'For Freelance',
    },
    {
      title:'Donation',
      localizing:'donation',
      img:require('@/assets/img/13Donation.png'),
      url:'donation',
      alt:'Donation',
    },
    {
      title:'Campaign Information',
      localizing:'campaignInfo',
      img:require('@/assets/img/14Campaign_Information.png'),
      url:'campaign',
      alt:'Campaign Information',
    }
];

export default {
    data () {
      return {
        links: _links,
      }
    }
  }
  